import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Box } from "@mui/material";
import classNames from "classnames";
// NOTE: 디자인 시스템이 나오지 않아 임의의 기본값을 설정합니다.
const DEFAULT_RADIUS_TEMP = 2;
const DEFAULT_BGCOLOR_TEMP = "white";
// TODO: Design System 적용 확인 필요 2024.04.30
export function GrSection(props) {
    return (_jsxs(Box, { className: classNames("GrSection", props.className), children: [props.heading && _jsx("h3", { children: props.heading }), _jsx(Box, { sx: { borderRadius: `${DEFAULT_RADIUS_TEMP}px`, backgroundColor: DEFAULT_BGCOLOR_TEMP, p: 2 }, children: props.children })] }));
}
//# sourceMappingURL=GrSection.js.map